import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export abstract class ISidebarCartService {

  public abstract sidebarShoppingCartChangedGet(): Observable<boolean>;

  public abstract sidebarShoppingCartShow(): void;

  public abstract sidebarShoppingCartHide(): void;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ISidebarCartServiceToken = new InjectionToken<ISidebarCartService>('ISidebarCartService');
